import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";

import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';

import { Modal, ModalDialog, ModalOverflow } from "@mui/joy";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// ─── Данные слайдов ───────────────────────────────────────────────────────────

const SLIDES = [
    // {
    //     imgPk: "./assets/onboarding/slide1.jpg",
    //     imgMobile: "./assets/mobile/slide1.jpg",

    //     emoji: "📖",
    //     color: "#171717",
    //     accent: "#f5f0e8",
    //     bg: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
    //     title: "Добро пожаловать в MagicBoard",
    //     subtitle: "Создайте свою уникальную фотокнигу за несколько шагов. Это проще, чем кажется.",
    //     visual: (
    //         <Box sx={{
    //             width: 180, height: 140,
    //             borderRadius: "16px",
    //             background: "rgba(255,255,255,0.08)",
    //             border: "1px solid rgba(255,255,255,0.12)",
    //             display: "flex", alignItems: "center", justifyContent: "center",
    //             fontSize: "64px",
    //             boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
    //         }}>
    //             <WavingHandRoundedIcon sx={{ color: "white", fontSize: 70 }} />
    //         </Box>
    //     ),
    // },
    {
        imgPk: "./assets/onboarding/slide1.png",
        imgMobile: "./assets/mobile/slide1.png",

        emoji: "📄",
        color: "#0f3460",
        accent: "#e8f0fe",
        bg: "linear-gradient(135deg, #0f3460 0%, #1a5276 100%)",
        title: "Выберите количество страниц",
        subtitle: "Чем больше страниц — тем больше воспоминаний. Выберите объём, который подойдёт для вашей истории.",
        visual: (
            <Stack direction="row" gap={2} alignItems="flex-end">
            {[
                { pages: 16, h: 50 },
                { pages: 32, h: 75 },
                { pages: 48, h: 100 },
                { pages: 96, h: 125 },
            ].map((b, i) => (
                <Box key={i} sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <Box sx={{
                    width: 52, height: b.h,
                    borderRadius: "8px",
                    background: i === 1
                    ? "rgba(255,255,255,0.30)"
                    : "rgba(255,255,255,0.10)",
                    border: i === 1
                    ? "2px solid rgba(255,255,255,0.7)"
                    : "1.5px solid rgba(255,255,255,0.2)",
                    boxShadow: i === 1 ? "0 8px 24px rgba(0,0,0,0.3)" : "none",
                    display: "flex", alignItems: "flex-end", justifyContent: "center",
                    pb: 1,
                }}>
                    {i === 1 && (
                    <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.9)", fontWeight: 700 }}>
                        ★
                    </Typography>
                    )}
                </Box>
                <Typography level="body-xs" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "11px", fontWeight: 600 }}>
                    {b.pages} стр.
                </Typography>
                </Box>
            ))}
            </Stack>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide2.png",
        imgMobile: "./assets/mobile/slide2.png",

        emoji: "🖼️",
        color: "#1a472a",
        accent: "#e8f5e9",
        bg: "linear-gradient(135deg, #1a472a 0%, #2d6a4f 100%)",
        title: "Добавляйте фото на развороты",
        subtitle: "Каждый разворот — это два листа. Выберите макет расположения фото и загрузите снимки.",
        visual: (
        <Box sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "6px",
            p: 1,
            width: 180, height: 130,
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 16px 40px rgba(0,0,0,0.35)",
        }}>
            {[0, 1, 2, 3].map(i => (
            <Box key={i} sx={{
                bgcolor: i === 0 || i === 3
                ? "rgba(255,255,255,0.20)"
                : "rgba(255,255,255,0.10)",
                borderRadius: "6px",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "22px",
            }}>
                {i === 0 ? "🌄" : i === 1 ? "🏙️" : i === 2 ? "🌿" : "🌊"}
            </Box>
            ))}
        </Box>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide3.png",
        imgMobile: "./assets/mobile/slide3.png",

        emoji: "✨",
        color: "#4a1942",
        accent: "#fce4ec",
        bg: "linear-gradient(135deg, #4a1942 0%, #6d2c5e 100%)",
        title: "Настройте обложку",
        subtitle: "Выберите шаблон обложки, добавьте текст, год и цвет. Или загрузите свои фото на заднюю часть.",
        visual: (
        <Box sx={{
            width: 120, height: 160,
            borderRadius: "12px",
            background: "linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))",
            border: "1.5px solid rgba(255,255,255,0.2)",
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            gap: 1,
            boxShadow: "0 20px 50px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.15)",
            position: "relative",
            overflow: "hidden",
        }}>
            <Box sx={{
                position: "absolute", inset: 0,
                background: "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.12) 0%, transparent 60%)",
            }} />
            <Typography sx={{ fontSize: "32px" }}>🌸</Typography>
            <Typography level="body-xs" sx={{
                color: "rgba(255,255,255,0.8)",
                fontWeight: 700, fontSize: "11px",
                letterSpacing: "0.05em",
                textAlign: "center", px: 1,
            }}>
                Пермь 2024
            </Typography>
        </Box>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide4.png",
        imgMobile: "./assets/mobile/slide4.png",

        emoji: "🛒",
        color: "#7b3f00",
        accent: "#fff3e0",
        bg: "linear-gradient(135deg, #7b3f00 0%, #a0522d 100%)",
        title: "Оформите заказ",
        subtitle: "Добавьте книгу в корзину, выберите доставку и оплатите онлайн. Мы напечатаем и пришлём!",
        visual: (
        <Stack direction="column" gap={1.5} alignItems="center">
            {[
            { icon: "🛒", text: "Добавить в корзину" },
            { icon: "📦", text: "Выбрать доставку" },
            { icon: "💳", text: "Оплатить" },
            ].map((step, i) => (
            <Box key={i} sx={{
                display: "flex", alignItems: "center", gap: 1.5,
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.18)",
                borderRadius: "10px",
                px: 2, py: 1,
                width: 200,
            }}>
                <Typography sx={{ fontSize: "18px" }}>{step.icon}</Typography>
                <Typography level="body-xs" sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>
                {step.text}
                </Typography>
                <Box sx={{ ml: "auto", width: 18, height: 18, borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "10px", color: "rgba(255,255,255,0.7)" }}>
                {i + 1}
                </Box>
            </Box>
            ))}
        </Stack>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide5.png",
        imgMobile: "./assets/mobile/slide5.png",

        emoji: "🛒",
        color: "#7b3f00",
        accent: "#fff3e0",
        bg: "linear-gradient(135deg, #7b3f00 0%, #a0522d 100%)",
        title: "Оформите заказ",
        subtitle: "Добавьте книгу в корзину, выберите доставку и оплатите онлайн. Мы напечатаем и пришлём!",
        visual: (
        <Stack direction="column" gap={1.5} alignItems="center">
            {[
            { icon: "🛒", text: "Добавить в корзину" },
            { icon: "📦", text: "Выбрать доставку" },
            { icon: "💳", text: "Оплатить" },
            ].map((step, i) => (
            <Box key={i} sx={{
                display: "flex", alignItems: "center", gap: 1.5,
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.18)",
                borderRadius: "10px",
                px: 2, py: 1,
                width: 200,
            }}>
                <Typography sx={{ fontSize: "18px" }}>{step.icon}</Typography>
                <Typography level="body-xs" sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>
                {step.text}
                </Typography>
                <Box sx={{ ml: "auto", width: 18, height: 18, borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "10px", color: "rgba(255,255,255,0.7)" }}>
                {i + 1}
                </Box>
            </Box>
            ))}
        </Stack>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide6.png",
        imgMobile: "./assets/mobile/slide6.png",

        emoji: "🛒",
        color: "#7b3f00",
        accent: "#fff3e0",
        bg: "linear-gradient(135deg, #7b3f00 0%, #a0522d 100%)",
        title: "Оформите заказ",
        subtitle: "Добавьте книгу в корзину, выберите доставку и оплатите онлайн. Мы напечатаем и пришлём!",
        visual: (
        <Stack direction="column" gap={1.5} alignItems="center">
            {[
            { icon: "🛒", text: "Добавить в корзину" },
            { icon: "📦", text: "Выбрать доставку" },
            { icon: "💳", text: "Оплатить" },
            ].map((step, i) => (
            <Box key={i} sx={{
                display: "flex", alignItems: "center", gap: 1.5,
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.18)",
                borderRadius: "10px",
                px: 2, py: 1,
                width: 200,
            }}>
                <Typography sx={{ fontSize: "18px" }}>{step.icon}</Typography>
                <Typography level="body-xs" sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>
                {step.text}
                </Typography>
                <Box sx={{ ml: "auto", width: 18, height: 18, borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "10px", color: "rgba(255,255,255,0.7)" }}>
                {i + 1}
                </Box>
            </Box>
            ))}
        </Stack>
        ),
    },
    {
        imgPk: "./assets/onboarding/slide7.png",
        imgMobile: "./assets/mobile/slide7.png",
        bg: "linear-gradient(135deg, #17313a 0%, #22505c 100%)",
        // Поля ниже в разметке сейчас не выводятся — оставлены для единообразия:
        emoji: "🖼️",
        color: "#17313a",
        accent: "#e8f6f9",
        title: "Новый слайд",
        subtitle: "Текст нового слайда.",
    },
    {
        imgPk: "./assets/onboarding/slide8.png",
        imgMobile: "./assets/mobile/slide8.png",
        bg: "linear-gradient(135deg, #17313a 0%, #22505c 100%)",
        // Поля ниже в разметке сейчас не выводятся — оставлены для единообразия:
        emoji: "🖼️",
        color: "#17313a",
        accent: "#e8f6f9",
        title: "Новый слайд",
        subtitle: "Текст нового слайда.",
    },
    {
        imgPk: "./assets/onboarding/slide9.png",
        imgMobile: "./assets/mobile/slide9.png",
        bg: "linear-gradient(135deg, #17313a 0%, #22505c 100%)",
        // Поля ниже в разметке сейчас не выводятся — оставлены для единообразия:
        emoji: "🖼️",
        color: "#17313a",
        accent: "#e8f6f9",
        title: "Новый слайд",
        subtitle: "Текст нового слайда.",
    },
    {
        imgPk: "./assets/onboarding/slide10.png",
        imgMobile: "./assets/mobile/slide10.png",
        bg: "linear-gradient(135deg, #17313a 0%, #22505c 100%)",
        // Поля ниже в разметке сейчас не выводятся — оставлены для единообразия:
        emoji: "🖼️",
        color: "#17313a",
        accent: "#e8f6f9",
        title: "Новый слайд",
        subtitle: "Текст нового слайда.",
    },
];

// ─── Точки пагинации ──────────────────────────────────────────────────────────

function Dots({ total, current }) {
  return (
    <Stack direction="row" gap={0.75} alignItems="center" justifyContent="center">
      {Array.from({ length: total }).map((_, i) => (
        <motion.div
          key={i}
          animate={{
            width: i === current ? 24 : 8,
            opacity: i === current ? 1 : 0.35,
          }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
          style={{
            height: 8,
            borderRadius: 4,
            background: "rgba(255,255,255,0.9)",
          }}
        />
      ))}
    </Stack>
  );
}

// ─── Основной компонент ───────────────────────────────────────────────────────

export default function ModalOnboarding({ open, onClose }) {
  const [swiper, setSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const isFirst = activeIndex === 0;
  const isLast = activeIndex === SLIDES.length - 1;
  const slide = SLIDES[activeIndex];

  const handleNext = () => {
    if (isLast) {
      onClose();
    } else {
      swiper?.slideNext();
    }
  };

  const handlePrev = () => {
    swiper?.slidePrev();
  };

  return (
    <AnimatePresence>
      {open && (
        <Modal
          open={open}
          onClose={undefined} // блокируем закрытие по клику на фон
          sx={{ zIndex: 10020 }}
          slotProps={{
            backdrop: {
              component: motion.div,
              initial: { opacity: 0, backdropFilter: "blur(0px)" },
              animate: { opacity: 1, backdropFilter: "blur(12px)" },
              exit: { opacity: 0, backdropFilter: "blur(0px)" },
              transition: { duration: 0.35, ease: "easeInOut" },
            },
          }}
        >
            <ModalOverflow sx={{ p: 0 }}>
                <ModalDialog
                    component={motion.div}
                    initial={{ opacity: 0, y: 24, scale: 0.97 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 16, scale: 0.97 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    sx={(theme) => ({
                        p: 0,
                        m: "0 !important",
                        overflow: "hidden",
                        border: "none",
                        // boxShadow: "0 32px 80px rgba(0,0,0,0.45)",
                        borderRadius: 0,
                        width: "100vw",
                        maxWidth: "100vw",
                        [theme.breakpoints.down("sm")]: {
                            maxWidth: "100vw",
                            width: "100vw",
                            minHeight: "100dvh",
                            borderRadius: 0,
                            m: "0 !important",
                            alignSelf: "flex-end",
                        },
                    })}
                >
                    {/* Фон — анимированный при смене слайда */}
                    <AnimatePresence>
                        <motion.div
                            key={activeIndex}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.5 }}
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: slide.bg,
                                zIndex: 0,
                            }}
                        />
                    </AnimatePresence>

                    {/* Контент */}
                    <Box sx={{ position: "relative", zIndex: 1 }}>

                    {/* Swiper */}
                    <Swiper
                        modules={[Pagination]}
                        onSwiper={setSwiper}
                        onSlideChange={(s) => setActiveIndex(s.activeIndex)}
                        allowTouchMove={true}
                        style={{ width: "100%" }}
                    >
                        {SLIDES.map((s, i) => (
                        <SwiperSlide key={i}>
                            
                            <Box sx={{
                                minHeight: { xs: "100dvh", sm: 540 },
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                px: { xs: 3, sm: 5 },
                                // pt: { xs: 6, sm: 5 },
                                pb: 2,
                                gap: 3,
                                textAlign: "center",
                            }}>

                                {/* <AnimatePresence mode="wait">
                                    <motion.div
                                        key={`visual-${i}`}
                                        initial={{ opacity: 0, y: 20, scale: 0.9 }}
                                        animate={{ opacity: 1, y: 0, scale: 1 }}
                                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                                        transition={{ duration: 0.35, ease: "easeOut" }}
                                        style={{ display: "flex", justifyContent: "center" }}
                                    >
                                    {s.visual}
                                    </motion.div>
                                </AnimatePresence>

                                <Stack gap={1.5} sx={{ maxWidth: 360 }}>
                                    <motion.div
                                    initial={{ opacity: 0, y: 12 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: 0.1 }}
                                    >
                                    <Typography
                                        level="h3"
                                        sx={{
                                        color: "#ffffff",
                                        fontWeight: 800,
                                        fontSize: { xs: "22px", sm: "26px" },
                                        letterSpacing: "-0.02em",
                                        lineHeight: 1.2,
                                        textShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        {s.title}
                                    </Typography>
                                    </motion.div>
                                    <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: 0.18 }}
                                    >
                                    <Typography
                                        level="body-md"
                                        sx={{
                                        color: "rgba(255,255,255,0.72)",
                                        lineHeight: 1.65,
                                        fontSize: { xs: "14px", sm: "15px" },
                                        }}
                                    >
                                        {s.subtitle}
                                    </Typography>
                                    </motion.div>
                                </Stack> */}

                                <Box 
                                    component={'img'}
                                    src={s.imgPk}
                                    sx={{ 
                                        height: "100dvh",
                                        width: "100dvw",
                                        objectFit: "cover",
                                    }} 
                                />

                                {/* Пустое место под кнопки */}
                                {/* <Box sx={{ height: { xs: 100, sm: 90 } }} /> */}
                            </Box>
                        </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Нижняя панель: точки + кнопки */}
                    <Box sx={{
                        position: "absolute",
                        bottom: 0, left: 0, right: 0,
                        px: { xs: 3, sm: 5 },
                        pb: { xs: 5, sm: 4 },
                        pt: 2,
                        background: "linear-gradient(to top, rgba(0,0,0,0.35) 0%, transparent 100%)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        zIndex: 10,
                    }}>

                        <Dots total={SLIDES.length} current={activeIndex} />

                        <Stack direction="row" gap={1.5} sx={{ maxWidth: 480, width: '100%', mx: "auto" }}>
                        {/* Кнопка "Назад" */}
                        <AnimatePresence>
                            {!isFirst && (
                            <motion.div
                                initial={{ opacity: 0, x: -10, width: 0 }}
                                animate={{ opacity: 1, x: 0, width: "auto" }}
                                exit={{ opacity: 0, x: -10, width: 0 }}
                                transition={{ duration: 0.2 }}
                                style={{ flexShrink: 0 }}
                            >
                                <Button
                                variant="plain"
                                onClick={handlePrev}
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    borderRadius: "14px",
                                    px: 2.5, py: 1.5,
                                    bgcolor: "rgba(255,255,255,0.1)",
                                    "&:hover": {
                                    bgcolor: "rgba(255,255,255,0.18)",
                                    color: "#fff",
                                    transform: "scale(1.02)",
                                    },
                                    whiteSpace: "nowrap",
                                }}
                                >
                                ← Назад
                                </Button>
                            </motion.div>
                            )}
                        </AnimatePresence>

                        {/* Кнопка "Далее" / "Готово" */}
                        <Button
                            fullWidth
                            size="lg"
                            onClick={handleNext}
                            sx={{
                            borderRadius: "14px",
                            fontWeight: 700,
                            fontSize: "15px",
                            py: 1.5,
                            bgcolor: "rgba(255,255,255,0.95)",
                            color: "#171717",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                            "&:hover": {
                                bgcolor: "#ffffff",
                                transform: "scale(1.02)",
                                boxShadow: "0 6px 28px rgba(0,0,0,0.3)",
                            },
                            transition: "all .2s",
                            }}
                        >
                            <AnimatePresence mode="wait">
                                <motion.span
                                    key={isLast ? "done" : "next"}
                                    initial={{ opacity: 0, y: 6 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -6 }}
                                    transition={{ duration: 0.15 }}
                                >
                                    {isLast ? "Готово 🎉" : "Далее →"}
                                </motion.span>
                            </AnimatePresence>
                        </Button>
                        </Stack>

                    </Box>
                    </Box>
                </ModalDialog>
            </ModalOverflow>
        </Modal>
      )}
    </AnimatePresence>
  );
}